// Shared phone helpers.
//
// `react-phone-input-2` calls onChange with the number INCLUDING the country
// dial code but WITHOUT a leading "+" (e.g. "201234567890"). Different forms in
// this app store the value either with or without the "+", so these helpers
// accept both shapes and normalise before validating.
import { isValidPhoneNumber } from 'libphonenumber-js';

// Normalise a raw phone value to E.164 (with a single leading "+").
// Returns "" for empty input.
export const toE164Phone = (raw) => {
  if (raw === undefined || raw === null) return '';
  const trimmed = String(raw).trim();
  if (!trimmed) return '';
  const digits = trimmed.replace(/[^\d]/g, '');
  if (!digits) return '';
  return `+${digits}`;
};

// True when `raw` is a valid phone number for its country (country is inferred
// from the dial code already embedded in the react-phone-input-2 value).
export const isValidPhone = (raw) => {
  const e164 = toE164Phone(raw);
  if (!e164) return false;
  try {
    return isValidPhoneNumber(e164);
  } catch {
    return false;
  }
};
